module.exports = __webpack_public_path__ + "static/img/26.cad72a1f.jpg";